import { mappingsToRigSignals, rigSignalsToMappings, baseRigSignalsFromRig } from './rigAdapter.js';

/**
 * Merge Mapping panel CC/note entries into performance.rig.signals; keep audio/engine defs.
 * @param {import('../core/StateManager.js').StateManager} state
 */
export function mergeRigIntoPerformance(state) {
  const perf = JSON.parse(JSON.stringify(state.get('performance')));
  if (!perf.rig) perf.rig = { signals: {} };
  const base = baseRigSignalsFromRig(perf.rig);
  perf.rig.signals = mappingsToRigSignals(
    state.get('midiCCMappings'),
    state.get('midiNoteMappings'),
    base
  );
  state.set('performance', perf);
}

/**
 * Replace performance + MIDI mapping state from a loaded document.
 * @param {import('../core/StateManager.js').StateManager} state
 * @param {object} perf
 */
export function applyPerformanceData(state, perf) {
  state.set('performance', JSON.parse(JSON.stringify(perf)));
  const { midiCCMappings, midiNoteMappings } = rigSignalsToMappings(perf.rig?.signals || {});
  state.set('midiCCMappings', midiCCMappings);
  state.set('midiNoteMappings', midiNoteMappings);

  const pmap = perf.programMap || {};
  const first =
    pmap['0'] ||
    pmap[0] ||
    Object.keys(perf.presets || {})[0] ||
    'main';
  state.set('activePresetKey', first);
}
